import { SkuImportFlow } from '@/components/import/sku-import-flow';

export default function AdminImportRoute() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-bold tracking-tight">Import SKUs</h1>
        <p className="text-sm text-muted-foreground">
          Upload file CSV báo giá để cập nhật danh sách SKUs. Hệ thống preview thay đổi trước khi áp dụng.
          Sales hàng tháng giờ được tích hợp trong flow tạo báo cáo (xem trang Báo cáo).
        </p>
      </header>

      <SkuImportFlow />
    </div>
  );
}
